import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import {  OrderDetailsService, OrderDetailTotalsComponent, OrderOverviewComponent } from '@spartacus/order/components';
import { KnBrOrderOverviewComponent } from '../../kn-br-order-overview/kn-br-order-overview.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'cx-order-confirmation-overview',
    templateUrl: './kn-br-order-confirmation-overview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [KnBrOrderOverviewComponent, AsyncPipe]
})
export class KnBrOrderConfirmationOverviewComponent extends OrderDetailTotalsComponent implements OnInit {
  constructor(protected orderDetailsService: OrderDetailsService) {
    super(orderDetailsService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  // ngOnDestroy() {
  //   super.ngOnDestroy();
  // }
}
